import { render, staticRenderFns } from "./SpamTweetsPerMinute.vue?vue&type=template&id=33299e48&"
import script from "./SpamTweetsPerMinute.vue?vue&type=script&lang=js&"
export * from "./SpamTweetsPerMinute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports